import { message, notification } from 'antd'
import { all, call, put, takeEvery } from 'redux-saga/effects'
import { actions } from 'src/redux/api-keys/actions'
import { serviceApiKeys } from 'src/services/api/apiKeys'

function load (payload) {
  return setState({ loading: payload })
}

function setState (payload) {
  return put({
    type: 'api_keys/set_state',
    payload
  })
}

export function * getApiKeys ({ payload }) {
  yield load(true)
  const { token, params } = payload

  const response = yield call(serviceApiKeys.get, token, params)
  if (response.status === 200) {
    yield setState({
      data: response.data.data.items,
      meta: response.data.data.meta,
      loading: false
    })
  } else yield load(false)
}

export function * createApiKey ({ payload }) {
  yield load(true)

  const { token, data } = payload

  const response = yield call(serviceApiKeys.post, token, data)

  if (response.status === 201) {
    yield put({
      type: 'api_keys/get_api_keys',
      payload: { token }
    })

    message.success('API Key berhasil dibuat!')
  } else {
    yield load(false)

    notification.error({
      message: 'Gagal membuat API Key!',
      description: response.data.message || 'Terjadi kesalahan saat membuat API Key'
    })
  }
}

export function * deleteApiKey ({ payload }) {
  yield load(true)

  const { token, apiKeyId } = payload

  const response = yield call(serviceApiKeys.delete, token, { apiKeyId })

  if (response.status === 200) {
    yield put({
      type: 'api_keys/get_api_keys',
      payload: { token }
    })

    message.success('API Key berhasil dihapus!')
  } else {
    yield load(false)

    notification.error({
      message: 'Gagal menghapus API Key!',
      description: response.data.message || 'Terjadi kesalahan saat menghapus API Key'
    })
  }
}

export default function * rootSaga () {
  yield all([
    takeEvery(actions.get_api_keys, getApiKeys),
    takeEvery(actions.create_api_key, createApiKey),
    takeEvery(actions.delete_api_key, deleteApiKey)
  ])
}
